import React, { JSX, useMemo } from 'react';

import { View } from 'react-native';

import { EPGConfig } from '../../types';
import getStyles from './styles';

type Props = {
    config: EPGConfig;
    renderContent?: () => JSX.Element;
};

const TopLeftAccessoryRenderer = ({ config, renderContent }: Props) => {
    const styles = useMemo(() => getStyles(config), [config]);

    return <View style={styles.container}>{renderContent?.()}</View>;
};

export default TopLeftAccessoryRenderer;
